import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Accept-Language": lang,
  };
};

const buildQueryParams = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return query.toString();
};

export const getInventoryReportFilters = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/inventory-report/filters`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Get Inventory Report Filters API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch inventory report filters",
    };
  }
};

export const getInventoryReportList = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/inventory-report/list${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Get Inventory Report List API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch inventory report",
    };
  }
};

export const exportInventoryReportExcel = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/inventory-report/export/excel${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `inventory-report-${Date.now()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error("Export Inventory Report Excel API Error:", error);
    throw error?.response?.data || {
      message: "Failed to export inventory report excel",
    };
  }
};

export const exportInventoryReportPdf = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/inventory-report/export/pdf${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `inventory-report-${Date.now()}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error("Export Inventory Report PDF API Error:", error);
    throw error?.response?.data || {
      message: "Failed to export inventory report pdf",
    };
  }
};